import { getEnvironmentInfo } from "shared/utils/config";
import sortBy from "lodash/sortBy";
import { ApiSocialPostTemplate } from "apps/console/modules/registration/configurations/socialMedia/list/types";
import { SocialMediaPlatform } from "shared/utils/enums";

export const SocialMediaUrl = {
  [SocialMediaPlatform.LINKEDIN]: "https://www.linkedin.com/sharing/share-offsite?url={urlToShare}",
  [SocialMediaPlatform.X]: "https://x.com/intent/post?url={urlToShare}"
};

export function getSocialMediaShareUrl(regParticipantId: string, platformName: string, timestamp: string) {
  return `${getEnvironmentInfo().apiUrl}/public/socialPosting/${regParticipantId}/${platformName}/${timestamp}`;
}

export function getSortedTemplateList(templateData?: Array<ApiSocialPostTemplate>) {
  return sortBy(templateData, template => [template.displayOrder, template.name?.toLowerCase()]);
}
